import { useNovelStore } from './ai-novel/novelStore';
import { AiNovelSetupScreen } from './ai-novel/AiNovelSetupScreen';
import { GamesHubScreen } from './GamesHubScreen';

/** Games View 内ルーティング（ハブ / セットアップ / エラー）。プレイは App 側でシェル外。 */
export function GamesScreen() {
  const phase = useNovelStore((s) => s.phase);
  const errorMessage = useNovelStore((s) => s.errorMessage);
  const openSetup = useNovelStore((s) => s.openSetup);
  const backToHub = useNovelStore((s) => s.backToHub);

  if (phase === 'error') {
    return (
      <div className="library-shell flex h-full flex-col">
        <header className="pt-safe-header shrink-0 border-b border-base-600/60 bg-[#07090f] px-4 pb-3">
          <h1 className="text-base font-semibold">AI Novel</h1>
        </header>
        <div className="flex min-h-0 flex-1 items-center justify-center px-4 pb-[calc(5.5rem+env(safe-area-inset-bottom,0px))]">
          <div className="card w-full max-w-md p-6 text-center">
            <p className="text-sm font-medium text-slate-100">ゲームの生成に失敗しました。</p>
            <p className="mt-2 text-sm leading-relaxed text-slate-400">
              {errorMessage || 'しばらくしてからもう一度お試しください。'}
            </p>
            <button type="button" className="btn-primary mt-6 w-full" onClick={openSetup}>
              Retry
            </button>
            <button type="button" className="btn-ghost mt-2 w-full" onClick={backToHub}>
              EmYu-Ba Games へ戻る
            </button>
          </div>
        </div>
      </div>
    );
  }

  if (phase === 'setup') return <AiNovelSetupScreen />;
  return <GamesHubScreen />;
}
